import React from 'react';

const AdminHome = () => {
    return (
        <main className='container'>
            <div className="card mt-3">
                <div className="card-body">
                    <h1>Bienvenido de vuelta Admin.</h1>
                </div>
            </div>
        </main>
    );
};

export default AdminHome;